import { render, staticRenderFns } from "./SMessage.vue?vue&type=template&id=64c4dbea&scoped=true&"
import script from "./SMessage.vue?vue&type=script&lang=ts&"
export * from "./SMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SMessage.vue?vue&type=style&index=0&id=64c4dbea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4dbea",
  null
  
)

export default component.exports